export const SUCCESS_GET_ALL_EMAIL_TEMPLATES = 'SUCCESS_GET_ALL_EMAIL_TEMPLATES';
export const FAILED_GET_ALL_EMAIL_TEMPLATES = 'FAILED_GET_ALL_EMAIL_TEMPLATES';
export const SUCCESS_GET_EMAIL_TEMPLATE = 'SUCCESS_GET_EMAIL_TEMPLATE';
export const FAILED_GET_EMAIL_TEMPLATE = 'FAILED_GET_EMAIL_TEMPLATE';
export const SUCCESS_CREATE_EMAIL_TEMPLATE = 'SUCCESS_CREATE_EMAIL_TEMPLATE';
export const FAILED_CREATE_EMAIL_TEMPLATE = 'FAILED_CREATE_EMAIL_TEMPLATE';
export const SUCCESS_UPDATE_EMAIL_TEMPLATE = 'SUCCESS_UPDATE_EMAIL_TEMPLATE';
export const FAILED_UPDATE_EMAIL_TEMPLATE = 'FAILED_UPDATE_EMAIL_TEMPLATE';
export const SUCCESS_DELETE_EMAIL_TEMPLATE = 'SUCCESS_DELETE_EMAIL_TEMPLATE';
export const FAILED_DELETE_EMAIL_TEMPLATE = 'FAILED_DELETE_EMAIL_TEMPLATE';




// WEBPACK FOOTER //
// src/state/constants/emailTemplateConstants.js